import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import moment from 'moment'

const PageConst = {
  ACTION: {
    C10402_init: {
      api: 'T2110TeacherAttendanceService.C10402_init',
      input: {
        teacher_no: null,
        attendance_date: null
      }
    },
    C10402_getTimeLimit: {
      api: 'M0040TimeLimitService.C10402_getTimeLimit',
      input: {}
    },
    C10402_doSave_t2111: {
      api: 'T2110TeacherAttendanceService.C10402_doSave_t2111',
      input: []
    },
    C10402_doSave_t2110_teacher: {
      api: 'T2110TeacherAttendanceService.C10402_doSave_t2110_teacher',
      input: {}
    },
    C10402_doSave_t2110_admin: {
      api: 'T2110TeacherAttendanceService.C10402_doSave_t2110_admin',
      input: {}
    },
  }
}

function minutesToHourMinutes(value) {
  if (value == null || isNaN(value)) {
    return '0:00'
  }
  const totalMinutes = Math.floor(Number(value))
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  // add thousands separators for hours if >= 1000
  const formattedHours = hours.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return `${formattedHours}:${minutes.toString().padStart(2, '0')}`
}

const module = {
  state: {
    PageConst,
    init: false,
    teacherNo: null,
    yearMonth: null,
    datesInMonth: [],
    timeLimit: [],
    dropdownHours: [],
    C10402_intermediateScheduleData: {},
    C10402_modifyData: {},

    t2010: {},
    t2110: null,
    t2111: [],
    t3010: [],
    t2050: [],
  },

  getters: {},
  mutations: {
    initData(state) {
      // Define variables
      const courseMinutes = 45

      state.C10402_intermediateScheduleData = {}
      state.C10402_modifyData = {}
      const courseMap = {}
      const modifyMap = {}
      let totalWorkMinutes = 0
      let totalSupportMinutes = 0

      // Initialize empty structure
      const startOfMonth = moment(state.yearMonth, 'YYYY-MM').startOf('month');
      const endOfMonth = moment(state.yearMonth, 'YYYY-MM').endOf('month');

      const datesInMonth = [];
      const currentDate = startOfMonth;

      while (currentDate.isSameOrBefore(endOfMonth, 'day')) {
        datesInMonth.push({
          date: currentDate.format('YYYY-MM-DD'),
          day: currentDate.format('D'),
          dayofweek_code: currentDate.isoWeekday() - 1,
          dayofweek_label: currentDate.format('dd'),
        });
        currentDate.add(1, 'day');
      }

      state.datesInMonth = datesInMonth

      datesInMonth.forEach(dateItem => {
        state.timeLimit.forEach(item => {
          const keyLeftUp = `${dateItem.date}_${item.time_limit_no}_1`
          const keyLeftBottom = `${dateItem.date}_${item.time_limit_no}_2`
          const keyRightUp = `${dateItem.date}_${item.time_limit_no}_1`
          const keyRightBottom = `${dateItem.date}_${item.time_limit_no}_2`
          const keyLeftTotal = `${dateItem.date}_${item.time_limit_no}_total`
          const keyRightTotal = `${dateItem.date}_${item.time_limit_no}_total`

          courseMap[keyLeftUp] = {}
          courseMap[keyLeftBottom] = {}
          courseMap[keyRightUp] = {}
          courseMap[keyRightBottom] = {}
          courseMap[keyLeftTotal] = {}
          courseMap[keyRightTotal] = {}
        })

        const keyWork = `${dateItem.date}_work`
        const keySupport = `${dateItem.date}_support`
        courseMap[keyWork] = {
          label: '0:00',
          value: 0,
        }
        courseMap[keySupport] = {
          label: '0:00',
          value: 0,
        }

        modifyMap[keyWork] = {
          value: -1,
          reason: '',
        }
        modifyMap[keySupport] = {
          value: -1,
          reason: '',
        }
      })

      // Initialize total keys
      const keyTotalWork = `total_work`
      const keyTotalSupport = `total_support`
      courseMap[keyTotalWork] = {
        label: '0:00',
        value: 0,
        render: 'bgWork'
      }
      courseMap[keyTotalSupport] = {
        label: '0:00',
        value: 0,
        render: 'bgSupport'
      }

      // Initialize dropdown values
      let dropdownValue = 0
      state.dropdownHours = [
        { value: -1, label: '' },
        { value: 0, label: '0:00' }
      ]
      state.timeLimit.forEach(item => {
        dropdownValue += courseMinutes
        state.dropdownHours.push({
          value: dropdownValue,
          label: minutesToHourMinutes(dropdownValue)
        })
      })

      // Insert data
      state.t3010.forEach(item => {
        const timeLimitGroup = item.time_limit_no.toString()[0]
        const keyLeftUp = `${item.schedule_date}_${timeLimitGroup}1_1`
        const keyLeftBottom = `${item.schedule_date}_${timeLimitGroup}1_2`
        const keyRightUp = `${item.schedule_date}_${timeLimitGroup}2_1`
        const keyRightBottom = `${item.schedule_date}_${timeLimitGroup}2_2`
        const keyLeftTotal = `${item.schedule_date}_${timeLimitGroup}1_total`
        const keyRightTotal = `${item.schedule_date}_${timeLimitGroup}2_total`

        if (item.course_setting_no === 100) {
          if(
            courseMap[keyLeftUp].label ||
            courseMap[keyLeftBottom].label ||
            courseMap[keyRightUp].label ||
            courseMap[keyRightBottom].label
          ){
            window.vue.$dialog.notify.error(`Duplicate t3010 for ${item.schedule_no}`);
            return
          }
          courseMap[keyLeftUp].label = item.label
          courseMap[keyLeftUp].data = item
          courseMap[keyLeftUp].render = 'bgWork'
          courseMap[keyLeftBottom].label = '↑'
          courseMap[keyLeftBottom].relatedKey = keyLeftUp
          courseMap[keyLeftBottom].render = 'bgWork'
          courseMap[keyRightUp].label = '←'
          courseMap[keyRightUp].relatedKey = keyLeftUp
          courseMap[keyRightUp].render = 'bgWork'
          courseMap[keyRightBottom].label = '↑'
          courseMap[keyRightBottom].relatedKey = keyLeftUp
          courseMap[keyRightBottom].render = 'bgWork'

          courseMap[keyLeftTotal].label = courseMinutes
          courseMap[keyLeftTotal].render = 'bgWork'
          courseMap[keyRightTotal].label = courseMinutes
          courseMap[keyRightTotal].render = 'bgWork'
        } else if (item.course_setting_no === 101) {
          if(courseMap[keyLeftUp].label || courseMap[keyLeftBottom].label){
            window.vue.$dialog.notify.error(`Duplicate t3010 for ${item.schedule_no}`);
            return
          }
          courseMap[keyLeftUp].label = item.label
          courseMap[keyLeftUp].data = item
          courseMap[keyLeftUp].render = 'bgWork'
          courseMap[keyLeftBottom].label = '↑'
          courseMap[keyLeftBottom].relatedKey = keyLeftUp
          courseMap[keyLeftBottom].render = 'bgWork'

          courseMap[keyLeftTotal].label = courseMinutes
          courseMap[keyLeftTotal].render = 'bgWork'
        } else if (item.course_setting_no === 102) {
          if(courseMap[keyRightUp].label || courseMap[keyRightBottom].label){
            window.vue.$dialog.notify.error(`Duplicate t3010 for ${item.schedule_no}`);
            return
          }
          courseMap[keyRightUp].label = item.label
          courseMap[keyRightUp].data = item
          courseMap[keyRightUp].render = 'bgWork'
          courseMap[keyRightBottom].label = '↑'
          courseMap[keyRightBottom].relatedKey = keyRightUp
          courseMap[keyRightBottom].render = 'bgWork'

          courseMap[keyRightTotal].label = courseMinutes
          courseMap[keyRightTotal].render = 'bgWork'
        } else if (item.course_setting_no === 200) {
          const firstRowExists = courseMap[keyLeftUp].label || courseMap[keyRightUp].label
          const secondRowExists = courseMap[keyLeftBottom].label || courseMap[keyRightBottom].label
          if(firstRowExists && secondRowExists){
            window.vue.$dialog.notify.error(`Duplicate t3010 for ${item.schedule_no}`);
            return
          }
          const freeKeyleft = firstRowExists ? keyLeftBottom : keyLeftUp
          const freeKeyRight = firstRowExists ? keyRightBottom : keyRightUp

          courseMap[freeKeyleft].label = item.label
          courseMap[freeKeyleft].data = item
          courseMap[freeKeyleft].render = 'bgWork'
          courseMap[freeKeyRight].label = '←'
          courseMap[freeKeyRight].relatedKey = freeKeyleft
          courseMap[freeKeyRight].render = 'bgWork'

          courseMap[keyLeftTotal].label = courseMinutes
          courseMap[keyLeftTotal].render = 'bgWork'
          courseMap[keyRightTotal].label = courseMinutes
          courseMap[keyRightTotal].render = 'bgWork'
        } else if (item.course_setting_no === 201) {
          if(courseMap[keyLeftUp].label && courseMap[keyLeftBottom].label){
            window.vue.$dialog.notify.error(`Duplicate t3010 for ${item.schedule_no}`);
            return
          }
          const freeKeyLeft = courseMap[keyLeftUp].label ? keyLeftBottom : keyLeftUp
          courseMap[freeKeyLeft].label = item.label
          courseMap[freeKeyLeft].data = item
          courseMap[freeKeyLeft].render = 'bgWork'

          courseMap[keyLeftTotal].label = courseMinutes
          courseMap[keyLeftTotal].render = 'bgWork'
        } else if (item.course_setting_no === 202) {
          if(courseMap[keyRightUp].label && courseMap[keyRightBottom].label){
            window.vue.$dialog.notify.error(`Duplicate t3010 for ${item.schedule_no}`);
            return
          }
          const freeKeyRight = courseMap[keyRightUp].label ? keyRightBottom : keyRightUp
          courseMap[freeKeyRight].label = item.label
          courseMap[freeKeyRight].data = item
          courseMap[freeKeyRight].render = 'bgWork'

          courseMap[keyRightTotal].label = courseMinutes
          courseMap[keyRightTotal].render = 'bgWork'
        }
      })
      state.t2050.forEach(item => {
        const timeLimitGroup = item.time_limit_no.toString()[0]
        const keyLeftUp = `${item.schedule_date}_${timeLimitGroup}1_1`
        const keyLeftBottom = `${item.schedule_date}_${timeLimitGroup}1_2`
        const keyRightUp = `${item.schedule_date}_${timeLimitGroup}2_1`
        const keyRightBottom = `${item.schedule_date}_${timeLimitGroup}2_2`
        const keyLeftTotal = `${item.schedule_date}_${timeLimitGroup}1_total`
        const keyRightTotal = `${item.schedule_date}_${timeLimitGroup}2_total`

        if (item.time_division === 1){
          if( courseMap[keyLeftUp].label ||courseMap[keyLeftBottom].label){
            window.vue.$dialog.notify.error(`Duplicate t2050 for ${item.schedule_no}`);
            return
          }
          courseMap[keyLeftUp].label = window.vue.$i18n.t('C10402.PgC10402.support')
          courseMap[keyLeftUp].data = item
          courseMap[keyLeftUp].render = 'bgSupport'
          courseMap[keyLeftBottom].label = '↑'
          courseMap[keyLeftBottom].relatedKey = keyLeftUp
          courseMap[keyLeftBottom].render = 'bgSupport'

          courseMap[keyLeftTotal].label = courseMinutes
          courseMap[keyLeftTotal].render = 'bgSupport'
        } else if (item.time_division === 2){
          if( courseMap[keyRightUp].label ||courseMap[keyRightBottom].label){
            window.vue.$dialog.notify.error(`Duplicate t2050 for ${item.schedule_no}`);
            return
          }
          courseMap[keyRightUp].label = window.vue.$i18n.t('C10402.PgC10402.support')
          courseMap[keyRightUp].data = item
          courseMap[keyRightUp].render = 'bgSupport'
          courseMap[keyRightBottom].label = '↑'
          courseMap[keyRightBottom].relatedKey = keyRightUp
          courseMap[keyRightBottom].render = 'bgSupport'

          courseMap[keyRightTotal].label = courseMinutes
          courseMap[keyRightTotal].render = 'bgSupport'
        }

        totalSupportMinutes += courseMinutes
        const newSupportValue = courseMap[`${item.schedule_date}_support`].value + courseMinutes
        courseMap[`${item.schedule_date}_support`].value = newSupportValue
        courseMap[`${item.schedule_date}_support`].label = minutesToHourMinutes(newSupportValue)
        courseMap[`${item.schedule_date}_support`].render = 'bgSupport'
      })
      state.t2111.forEach(item => {
        const keyWork = `${item.attendance_date}_work`
        const keySupport = `${item.attendance_date}_support`
        const keyData = `${item.attendance_date}_data`

        modifyMap[keyWork] = {
          value: item.final_teaching_minutes || 0,
          reason: item.teaching_correction_reason || '',
        }
        modifyMap[keySupport] = {
          value: item.final_support_minutes || 0,
          reason: item.support_correction_reason || '',
        }
        modifyMap[keyData] = item
      })

      // Calculate total work
      datesInMonth.forEach(dateItem => {
        state.timeLimit.forEach(item => {
          const keyTotalWorkByTimeLimit = `${dateItem.date}_${item.time_limit_no}_total`

          if (courseMap[keyTotalWorkByTimeLimit].render === 'bgWork') {
            totalWorkMinutes += courseMinutes
            const newWorkValue = courseMap[`${dateItem.date}_work`].value + courseMinutes
            courseMap[`${dateItem.date}_work`].value = newWorkValue
            courseMap[`${dateItem.date}_work`].label = minutesToHourMinutes(newWorkValue)
            courseMap[`${dateItem.date}_work`].render = 'bgWork'
          }
        })
      })

      // Set total minutes
      courseMap[keyTotalWork].value = totalWorkMinutes
      courseMap[keyTotalWork].label = minutesToHourMinutes(totalWorkMinutes)
      courseMap[keyTotalSupport].value = totalSupportMinutes
      courseMap[keyTotalSupport].label = minutesToHourMinutes(totalSupportMinutes)

      // Assign to state
      state.C10402_intermediateScheduleData = courseMap;
      state.C10402_modifyData = modifyMap;
    }
  },
  actions: {
    async C10402_init ({ state }, payload ) {
      const res = await $this.$api.postData({
        data: {
          C10402_init: {
            ...PageConst.ACTION.C10402_init,
            input: {
              teacher_no: payload.teacher_no,
              attendance_date: payload.year_month,
            }
          },
          C10402_getTimeLimit: PageConst.ACTION.C10402_getTimeLimit
        }
      }).catch((e) => {
        this.commit('Notification/SET_NOTIFY_ERROR', {
          text: e.message
        })
      })
      const C10402_init = res.C10402_init.output
      state.t2110 = C10402_init.t2110
      state.t2111 = C10402_init.t2111
      state.t3010 = C10402_init.t3010
      state.t2050 = C10402_init.t2050
      state.t2010 = C10402_init.t2010
      state.timeLimit = res.C10402_getTimeLimit.output
      state.teacherNo = payload.teacher_no
      state.yearMonth = payload.year_month

      await this.commit('C10402/initData')
      state.init = true
    },
    async C10402_doSave_t2111 ({ state }, payload ) {
      const res = await $this.$api.postData({
        data: {
          C10402_doSave_t2111: {
            ...PageConst.ACTION.C10402_doSave_t2111,
            input: payload
          },
        }
      })
      return res.C10402_doSave_t2111.output
    },
    async C10402_doSave_t2110_teacher ({ state }, payload ) {
      const res = await $this.$api.postData({
        data: {
          C10402_doSave_t2110_teacher: {
            ...PageConst.ACTION.C10402_doSave_t2110_teacher,
            input: payload
          },
        }
      })
      return res.C10402_doSave_t2110_teacher.output
    },
    async C10402_doSave_t2110_admin ({ state }, payload ) {
      const res = await $this.$api.postData({
        data: {
          C10402_doSave_t2110_admin: {
            ...PageConst.ACTION.C10402_doSave_t2110_admin,
            input: payload
          },
        }
      })
      return res.C10402_doSave_t2110_admin.output
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
